import { render, staticRenderFns } from "./EditRegisterList.vue?vue&type=template&id=5074fc29&scoped=true"
import script from "./EditRegisterList.vue?vue&type=script&lang=js"
export * from "./EditRegisterList.vue?vue&type=script&lang=js"
import style0 from "./EditRegisterList.vue?vue&type=style&index=0&id=5074fc29&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074fc29",
  null
  
)

export default component.exports